import * as ACTION from 'constant/action/organisation'
import { handleActions } from 'redux-actions'

const initialState = {
  organisations: []
}

export default handleActions(
  {
    [ACTION.UPDATE_ORGANISATIONS]: (state, action) => ({
      ...state,
      organisations: action.payload
    })
  },
  initialState
)
